export default __webpack_public_path__ + "static/media/scooter.f1f6e5fe.svg";